import { render, staticRenderFns } from "./sortable.vue?vue&type=template&id=c70e9186&"
import script from "./sortable.vue?vue&type=script&lang=js&"
export * from "./sortable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports